import { AttributeStatus, AttributeType } from 'companySettings/enums';
import { Color } from 'theme/enums';
import { IColorMap } from 'theme/types';

// The design draws "Modified" in purple, which the theme palette does not have.
export const attributeStatusColorMap: IColorMap = {
  [AttributeStatus.DRAFT]: Color.WARNING,
  [AttributeStatus.MODIFIED]: Color.PRIMARY,
  [AttributeStatus.PUBLISHED]: Color.SUCCESS,
  [AttributeStatus.UNPUBLISHED]: Color.NEUTRAL,
  [AttributeStatus.UNPUBLISHED_MODIFIED]: Color.PRIMARY,
};

export const attributeStatusLabelKey: Record<AttributeStatus, string> = {
  [AttributeStatus.DRAFT]: 'labelAttributeStatusDraft',
  [AttributeStatus.MODIFIED]: 'labelAttributeStatusModified',
  [AttributeStatus.PUBLISHED]: 'labelAttributeStatusPublished',
  [AttributeStatus.UNPUBLISHED]: 'labelAttributeStatusUnpublished',
  [AttributeStatus.UNPUBLISHED_MODIFIED]: 'labelAttributeStatusUnpublishedModified',
};

export const attributeTypeLabelKey: Record<AttributeType, string> = {
  [AttributeType.COLOUR]: 'labelAttributeTypeColour',
  [AttributeType.NUMBER_RANGE]: 'labelAttributeTypeNumberRange',
  [AttributeType.VALUES]: 'labelAttributeTypeValues',
};
